import apiService from './api.js';

export const lawyerPartnersService = {
  async getPartners(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.classificacao) queryParams.append('classificacao', params.classificacao);
    if (params.search) queryParams.append('search', params.search);

    return apiService.get(`/lawyer-partners${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
  },

  async getStats() {
    return apiService.get('/lawyer-partners/stats');
  },

  async getPartnerProcessDetails(id) {
    return apiService.get(`/lawyer-partners/${id}/process-details`);
  },

  async createPartner(payload) {
    return apiService.post('/lawyer-partners', payload);
  },

  async updatePartner(id, payload) {
    return apiService.put(`/lawyer-partners/${id}`, payload);
  },

  async deletePartner(id) {
    return apiService.delete(`/lawyer-partners/${id}`);
  },


  async enrichFromDocument(document) {
    return apiService.post('/lawyer-partners/enrich', { document });
  },
};

export default lawyerPartnersService;
